module.exports = __webpack_public_path__ + "img/productSystemMobile_bg.fee4c896.png";